/* ============================================================================
   MRT / LRT Station Intelligence page  ·  assets/mrt-station.js
   Paired with sections/mrt-station.liquid + assets/mrt-station.css.

   All page data is server-rendered by the Liquid section (SEO-safe); this
   file toggles visibility, plus a page-scoped grow-up observer (same
   canonical one-time settle-on-scroll as layout/theme.liquid, just
   guaranteed to fire on this template -- see roncasa-hub-page reference).

   Scoped to each section root ([data-mrt-root]) so it is safe if the section
   is ever placed more than once, and re-inits on Shopify theme-editor reload.
   ========================================================================== */
(function () {
  'use strict';

  function initRoot(root) {
    if (!root || root.__mrtInit) return;
    root.__mrtInit = true;

    /* Nearby list + area map are folded into one section with one filter --
       markers are populated by the Leaflet block further down; the explorer's
       cat-pills read/write this so the list and the map pins never disagree
       (see roncasa-shopify-hub skill: one shared, identically-filtered array). */
    var mapMarkers = [];
    var mrtLeafletMap = null;
    function applyMapCatFilter(cat) {
      if (!mrtLeafletMap) return;
      mapMarkers.forEach(function (mm) {
        var show = cat === 'all' || mm.cat === cat;
        var onMap = mrtLeafletMap.hasLayer(mm.marker);
        if (show && !onMap) { mm.marker.addTo(mrtLeafletMap); }
        else if (!show && onMap) { mrtLeafletMap.removeLayer(mm.marker); }
      });
    }

    /* ---- Radius explorer: band tabs + category pills ---------------------- */
    var explorer = root.querySelector('[data-explorer]');
    if (explorer) {
      var state = { band: explorer.getAttribute('data-default-band') || '5', cat: 'all' };
      var rows = Array.prototype.slice.call(explorer.querySelectorAll('.loc-row[data-band]'));
      var empties = Array.prototype.slice.call(explorer.querySelectorAll('.empty-state[data-band]'));
      var grpLabels = Array.prototype.slice.call(explorer.querySelectorAll('.loc-grp-label[data-band]'));
      var notes = Array.prototype.slice.call(explorer.querySelectorAll('.band-note[data-band]'));
      var dots = Array.prototype.slice.call(explorer.querySelectorAll('.mini-map .dotp[data-band]'));
      var bandBtns = Array.prototype.slice.call(explorer.querySelectorAll('[data-group="band"] button'));
      var catBtns = Array.prototype.slice.call(explorer.querySelectorAll('[data-group="cat"] .cp'));

      var applyExplorer = function () {
        var catMatch = function (el) { return state.cat === 'all' || el.getAttribute('data-cat') === state.cat; };
        rows.forEach(function (r) {
          r.hidden = !(r.getAttribute('data-band') === state.band && catMatch(r));
        });
        empties.forEach(function (e) {
          e.hidden = !(e.getAttribute('data-band') === state.band && catMatch(e));
        });
        grpLabels.forEach(function (g) {
          g.hidden = !(g.getAttribute('data-band') === state.band && catMatch(g));
        });
        notes.forEach(function (n) { n.hidden = n.getAttribute('data-band') !== state.band; });
        dots.forEach(function (d) { d.hidden = d.getAttribute('data-band') !== state.band; });
        applyMapCatFilter(state.cat);
      };

      bandBtns.forEach(function (b) {
        b.addEventListener('click', function () {
          bandBtns.forEach(function (x) { x.classList.remove('on'); });
          b.classList.add('on');
          state.band = b.getAttribute('data-band');
          applyExplorer();
        });
      });
      catBtns.forEach(function (c) {
        c.addEventListener('click', function () {
          catBtns.forEach(function (x) { x.classList.remove('on'); });
          c.classList.add('on');
          state.cat = c.getAttribute('data-cat');
          applyExplorer();
        });
      });
      applyExplorer();
    }

    /* ---- Recently transacted: New Launch / Resale / HDB tabs -------------- */
    var rtSection = root.querySelector('[data-recent-txn]');
    if (rtSection) {
      var rtBtns = Array.prototype.slice.call(rtSection.querySelectorAll('[data-group="txncat"] .cp'));
      var rtItems = Array.prototype.slice.call(rtSection.querySelectorAll('[data-txncat]'));
      var applyRtCat = function (cat) {
        rtBtns.forEach(function (b) { b.classList.toggle('on', b.getAttribute('data-txncat') === cat); });
        rtItems.forEach(function (it) {
          it.hidden = !(cat === 'all' || it.getAttribute('data-txncat') === cat);
        });
      };
      rtBtns.forEach(function (b) {
        b.addEventListener('click', function () { applyRtCat(b.getAttribute('data-txncat')); });
      });
      applyRtCat('all');
    }

    /* ---- Price grid: band tabs (swap which band table block is shown) ----- */
    var grid = root.querySelector('[data-price-grid]');
    if (grid) {
      var pBtns = Array.prototype.slice.call(grid.querySelectorAll('[data-group="pband"] button'));
      var pBands = Array.prototype.slice.call(grid.querySelectorAll('.price-band[data-pband]'));
      var showP = function (band) {
        pBtns.forEach(function (b) { b.classList.toggle('on', b.getAttribute('data-pband') === band); });
        pBands.forEach(function (p) { p.classList.toggle('on', p.getAttribute('data-pband') === band); });
      };
      pBtns.forEach(function (b) {
        b.addEventListener('click', function () { showP(b.getAttribute('data-pband')); });
      });
      var onBtn = grid.querySelector('[data-group="pband"] button.on');
      showP(onBtn ? onBtn.getAttribute('data-pband') : (grid.getAttribute('data-default-band') || '15'));

      /* ---- Bedroom pills: filter price rows by bed_key ------------------- */
      var bedBtns = Array.prototype.slice.call(grid.querySelectorAll('[data-group="bed"] .cp'));
      var bedState = 'all';
      var applyBed = function () {
        Array.prototype.slice.call(grid.querySelectorAll('.price-table tbody')).forEach(function (tb) {
          var groups = [], cur = null;
          Array.prototype.slice.call(tb.children).forEach(function (tr) {
            if (tr.classList.contains('cat-row')) { cur = { head: tr, rows: [] }; groups.push(cur); }
            else if (tr.hasAttribute('data-bed') && cur) { cur.rows.push(tr); }
          });
          groups.forEach(function (g) {
            var anyVisible = false;
            g.rows.forEach(function (tr) {
              var match = (bedState === 'all' || tr.getAttribute('data-bed') === bedState);
              tr.hidden = !match; if (match) anyVisible = true;
            });
            if (g.rows.length) g.head.hidden = !anyVisible;
          });
        });
      };
      bedBtns.forEach(function (b) {
        b.addEventListener('click', function () {
          bedBtns.forEach(function (x) { x.classList.remove('on'); });
          b.classList.add('on');
          bedState = b.getAttribute('data-bed');
          applyBed();
        });
      });
    }

    /* ---- School P1 ballot trend bars (shared p1-trend.liquid component) --- */
    var schoolsDataEl = document.getElementById('mrt-schools-data');
    if (schoolsDataEl && window.RoncasaP1Trend) {
      try {
        var schoolsData = JSON.parse(schoolsDataEl.textContent);
        Array.prototype.slice.call(root.querySelectorAll('.rc-p1t-slot[data-school-idx]')).forEach(function (slot) {
          var sc = schoolsData[parseInt(slot.getAttribute('data-school-idx'), 10)];
          if (sc && sc.p1_ballot_history && sc.p1_ballot_history.length) {
            RoncasaP1Trend.render(slot, sc.p1_ballot_history);
          }
        });
      } catch (e) { /* trend bars are enhancement-only */ }
    }

    /* ---- Area map (Leaflet), folded into the same "Nearby" section -------- */
    var mapEl = root.querySelector('#mrt-leaflet-map');
    var mapDataEl = document.getElementById('mrt-map-data');
    if (mapEl && mapDataEl && window.L && !mapEl.__init) {
      mapEl.__init = true;
      try {
        var cfg = JSON.parse(mapDataEl.textContent);
        // This is a small locator map inside a scrolling page, not a primary
        // nav tool -- disable every gesture that can hijack page scroll/swipe
        // (mouse-wheel zoom, click-drag pan, one-finger touch pan/zoom). Pins
        // stay clickable for their popups; zoom +/- buttons still work since
        // clicking them can't conflict with scrolling.
        mrtLeafletMap = L.map(mapEl, {
          scrollWheelZoom: false, dragging: false, touchZoom: false,
          doubleClickZoom: false, boxZoom: false, keyboard: false, tap: false
        }).setView([cfg.center.lat, cfg.center.lng], cfg.zoom || 15);
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
          { maxZoom: 19, attribution: '&copy; OpenStreetMap' }).addTo(mrtLeafletMap);
        // Pulsing station marker (divIcon + CSS animation) so it's easy to spot.
        var heroEl = root.querySelector('.rc-mrt-hero') || root;
        var lc = (getComputedStyle(heroEl).getPropertyValue('--mrt-line-color') || '#009645').trim() || '#009645';
        var pulse = L.divIcon({ className: 'mrt-stn-icon', iconSize: [20, 20], iconAnchor: [10, 10],
          html: '<span class="mrt-stn-ring" style="background:' + lc + '"></span><span class="mrt-stn-dot" style="background:' + lc + '"></span>' });
        L.marker([cfg.center.lat, cfg.center.lng], { icon: pulse, zIndexOffset: 1000 })
          .addTo(mrtLeafletMap).bindPopup('<b>' + (cfg.station || 'Station') + '</b>');
        var op = { 'new': 1, hdb: 0.78, resale: 0.5 };
        (cfg.pins || []).forEach(function (p) {
          var m = L.circleMarker([p.lat, p.lng],
            { radius: 5, stroke: false, fillColor: '#0E0E0E', fillOpacity: (op[p.cat] != null ? op[p.cat] : 0.6) }).addTo(mrtLeafletMap);
          var html = '<b>' + p.name + '</b><br>' + p.dist;
          if (p.href) { html += '<br><a href="' + p.href + '">View &rarr;</a>'; }
          m.bindPopup(html);
          mapMarkers.push({ marker: m, cat: p.cat });
        });
        // Respect whatever cat filter is already active (normally 'all' --
        // this only matters if a click landed before the map finished loading).
        applyMapCatFilter(explorer ? state.cat : 'all');
      } catch (e) { /* map is enhancement-only */ }
    }

    /* ---- Sticky anchor-nav scroll-spy ------------------------------------- */
    var nav = root.querySelector('.anchor-nav');
    if (nav && 'IntersectionObserver' in window) {
      var links = Array.prototype.slice.call(nav.querySelectorAll('a[href^="#"]'));
      var byId = {};
      links.forEach(function (a) { byId[a.getAttribute('href').slice(1)] = a; });
      var secs = links
        .map(function (a) { return root.querySelector('#' + CSS.escape(a.getAttribute('href').slice(1))); })
        .filter(Boolean);
      var spy = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            links.forEach(function (a) { a.classList.remove('active'); });
            var a = byId[en.target.id];
            if (a) {
              a.classList.add('active');
              /* Keep the active tab visible in the horizontally-scrolling
                 nav bar (mobile has more tabs than fit) by centering it,
                 instead of letting it scroll off-screen as sections pass. */
              a.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
            }
          }
        });
      }, { rootMargin: '-45% 0px -50% 0px' });
      secs.forEach(function (s) { spy.observe(s); });
    }

    /* ---- Grow-up headings: handled by the sitewide observer in theme.liquid -- */
    /* Removed the page-specific duplicate that used to live here. The sitewide
       script (layout/theme.liquid, same 'h1 em, h2 em...' selector) already
       runs on every page including this one and is already bidirectional
       (mutes on scroll-out, grows again on scroll-in) -- proven working on
       Tools Hub, which relies on that single sitewide observer with nothing
       page-specific. Having a second observer here watching the same elements
       was redundant and is the likely cause of the effect looking "stuck
       grown" on this page while Tools Hub worked fine (13 Sep 2026). */
  }

  function initAll() {
    document.querySelectorAll('[data-mrt-root]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  // Shopify theme editor: re-init when the section is re-rendered
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-mrt-root]');
    if (root) { root.__mrtInit = false; initRoot(root); }
  });
})();
